import { BrowserRouter } from "react-router-dom";
import { SessionContext, SessionProvider } from "./context/SessionContext";
import SolutionsNavigation from "./components/navigationComponents/solutions/SolutionsNavigation";
import "./assets/fontawesome/css/all.css";

function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <SessionContext.Consumer>
          {({ isLoading }) =>
            !isLoading && (
              <SolutionsNavigation
                hideItem={["notifications", "translations"]}
              />
            )
          }
        </SessionContext.Consumer>
      </SessionProvider>
    </BrowserRouter>
  );
}

let customerId = "";

export function setAppCustomerId(id: string) {
  customerId = id;
}

export function getAppCustomerId(): string {
  return customerId;
}

export { App };
